// tanstack
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive/',
)({
  beforeLoad: () =>
    redirect({
      to: '../',
      replace: true,
    }),
});
